import * as React from "react";
import defaultStyle from "./ITDILDSliderBlockView.module.scss";
import { BlockBase, useBlocks, useUi } from "@jelly/lesson";
import classnames from "classnames";
import Slider from "@src/lms/jelly/extensions/components/slider/Slider";
import config from "appConfig";

export interface IDSliderBlock extends BlockBase {
  type: "itdSlider";
}

export const IDSliderBlockView: React.FC<IDSliderBlock> = () => {
  //slider indexes start from 1, as when you set them to start from 0 they mess up marks, so
  //here we add one empty slot to fix that
  const ildFileNamePart = ["none", "ild_0", "ild_5", "ild_10", "ild_15", "ild_20", "ild_25"];
  const itdFileNamePart = ["none", "itd_0.00", "itd_0.15", "itd_0.30", "itd_0.45", "itd_0.60", "itd_0.75"];

  const [itdValue, setITDValue] = React.useState<number>(1);
  const [ildValue, setILDValue] = React.useState<number>(1);
  const [autoplay, setAutoplay] = React.useState(false);
  const [fileUrl, setFileUrl] = React.useState<string>(
    `${config.STATIC_ASSETS_URL}/lms/lesson/course01/lesson07/principle01/${itdFileNamePart[1]}_${ildFileNamePart[1]}.mp3`
  );

  const block = useBlocks();
  const { Button, Pill } = useUi();

  const handelItdSwitch = (index: number): void => {
    setITDValue(index);
    setFileUrl(
      `${config.STATIC_ASSETS_URL}/lms/lesson/course01/lesson07/principle01/${itdFileNamePart[index]}_${ildFileNamePart[ildValue]}.mp3`
    );
    setAutoplay(true);
  };
  const handelIldSwitch = (index: number): void => {
    setILDValue(index);
    setFileUrl(
      `${config.STATIC_ASSETS_URL}/lms/lesson/course01/lesson07/principle01/${itdFileNamePart[itdValue]}_${ildFileNamePart[index]}.mp3`
    );
    setAutoplay(true);
  };

  const toggleAutoplay = (): void => {
    setAutoplay(!autoplay);
  };

  return (
    <div className={classnames(defaultStyle.root)}>
      <div className={classnames(defaultStyle.slidersContainer)}>
        <div className={classnames(defaultStyle.sliderRow)}>
          <div className={classnames(defaultStyle.pillContainer)}>
            <Pill>ITD</Pill>
          </div>
          <Slider
            theme="primary"
            value={itdValue}
            min={1}
            max={6}
            onChange={(val) => handelItdSwitch(val)}
            marks={["0 ms", "0.15 ms", "0.30 ms", "0.45 ms", "0.60 ms", "0.75 ms"]}
          />
        </div>
        <div className={classnames(defaultStyle.sliderRow)}>
          <div className={classnames(defaultStyle.pillContainer)}>
            <Pill>ILD</Pill>
          </div>
          <Slider
            theme="primary"
            value={ildValue}
            min={1}
            max={6}
            onChange={(val) => handelIldSwitch(val)}
            marks={["0 db", "5 db", "10 db", "15 db", "20 db", "25 db"]}
          />
        </div>
      </div>
      <div className={classnames(defaultStyle.buttonRow)}>
        <Button
          onClick={() => {
            toggleAutoplay();
          }}
          icon={autoplay ? "cis-media-pause" : "cis-media-play"}
          theme="secondary"
          shape="round"
        >
          Play
        </Button>
      </div>
      {autoplay && (
        <block.audio src={fileUrl} autoplay={autoplay} key={`${itdValue}_${ildValue}`} styles={{ display: "none" }} />
      )}
    </div>
  );
};
